// ============================================================
// base-publica.js — Prefijo de las rutas PÚBLICAS del tenant (SSOT)
// ============================================================
//
// Los endpoints públicos del builder (`/site_lead/`, `/site_reserva/…`) están montados en la
// RAÍZ del tenant (web/urls.py). Qué prefijo hay que anteponerles depende de la superficie, y
// son TRES, no dos:
//
//   1. SITIO PUBLICADO — `templates/sites/page_detail.html`, servido en el subdominio/dominio
//      del tenant. No declara `BUILDER_BASE` ⇒ prefijo '' (la ruta raíz-relativa ya es buena).
//   2. SPA PÚBLICA EN VIVO — `views.py::_render_builder_public` sirve `ver_sitio.html` en el
//      subdominio del tenant cuando el sitio aún no tiene `EcommerceConfig` (borrador en vivo).
//      Ahí conviven `BUILDER_BASE="/{tenant}/builder"` **y** `IS_PUBLIC=true`: la página YA está
//      en el host del tenant, así que prefijar mandaría el POST a `/{tenant}/site_lead/` → 404
//      (se lo come el catch-all `blog_category` de web/urls.py) y el envío se pierde en
//      silencio. Por eso `IS_PUBLIC` manda sobre `BUILDER_BASE` y el prefijo vuelve a ser ''.
//   3. EDITOR / "Ver Sitio" — `/{tenant}/builder/sitio/<id>/`, sin `IS_PUBLIC`. Aquí una URL
//      raíz-relativa apunta a un host SIN tenant, así que se prefija `/{tenant}`.
//
// La regla de la superficie 2 vivía PARCHEADA en `animations/form-submit.js`
// (`window.IS_PUBLIC ? '' : basePublica()`), de modo que `core/reserva-live-runtime.js` —el otro
// consumidor, con sus cuatro llamadas de slots/lead/confirmar/cancelar— seguía prefijando y
// seguía dando 404 en esa misma superficie. Al vivir aquí, los dos quedan arreglados por la SSOT
// y cualquier consumidor futuro nace correcto.
//
// Módulo PURO (sin imports, sin DOM más allá de `window`) → node-testeable.
export function basePublica() {
    const w = typeof window !== 'undefined' ? window : {};
    if (w.IS_PUBLIC) return '';
    const b = w.BUILDER_BASE || '';
    return b ? String(b).replace(/\/builder\/?$/, '') : '';
}

// Prefijo de los endpoints del BUILDER que tienen GEMELA PÚBLICA en la raíz del tenant (mismo
// contrato; hoy `/api/buscar-foto/` → `web/urls.py`, `{url}`, cupo por IP). En el editor y el
// creador, `/{tenant}/builder` (el del builder: sesión + permiso); en la SPA en vivo y en el
// publicado, '' (la gemela). Leer `BUILDER_BASE` a pelo mandaba al visitante de la SPA al del
// builder → 302 al login → todas las fotos por keyword en gris. Misma regla de superficies que
// `basePublica()`, de la que se deriva (también normaliza una `BUILDER_BASE` con barra final).
export function baseApiConGemela() {
    const b = basePublica();
    return b ? b + '/builder' : '';
}
